import { featureToggles } from '@grandvisionhq/www-next/configuration'

export const pathOverrideConfig = {
  checkForBloomreachPathOverride: featureToggles.isPdpBloomreachPathOverrideEnabled,
}
